import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { action, observable, runInAction } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { CategoryCleaningStateLayer } from '../../transportLayers/data-cleaning/CategoryCleaningStateLayer';
import { ProgressMonitorLayer } from '../../transportLayers/progress-monitor/ProgressMonitorLayer';
import { CONSTANTS } from '../../../constants';
import { default as moment } from 'moment';
/**
 * This store obtaining data cleaning category state - new
 */

export var CategoryCleaningStateStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CategoryCleaningStateStore, _BaseStore);

  function CategoryCleaningStateStore() {
    var _this;

    _classCallCheck(this, CategoryCleaningStateStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoryCleaningStateStore).apply(this, arguments));
    _this.name = StoreName.CleaningState;
    _this.categoryCleaningStateLayer = new CategoryCleaningStateLayer();
    _this.progressMonitorLayer = new ProgressMonitorLayer();
    _this.list = new Map();

    _this.getOne = function (id) {
      _this.list.clear();

      return _this.categoryCleaningStateLayer.findOne(id).then(function (categoryCleaningState) {
        return categoryCleaningState;
      });
    };

    return _this;
  }

  _createClass(CategoryCleaningStateStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      this.list.clear();
      return this.categoryCleaningStateLayer.getAll().then(function (categoryCleaningStates) {
        runInAction(function () {
          categoryCleaningStates.forEach(function (categoryCleaningState) {
            _this2.list.set(categoryCleaningState.categoryId, categoryCleaningState);
          });
        });
      });
    }
  }, {
    key: "approveCategories",
    value: function approveCategories(categoryIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.categoryCleaningStateLayer.approveCategories(categoryIds);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "startCleaning",
    value: function startCleaning() {
      var _this3 = this;

      return this.categoryCleaningStateLayer.startCleaning().then(function (progressMonitor) {
        _this3.progressMonitor = progressMonitor;
      });
    }
  }, {
    key: "getLastCleaning",
    value: function getLastCleaning() {
      var _this4 = this;

      return this.categoryCleaningStateLayer.lastCleaning().then(function (ISODate) {
        runInAction(function () {
          _this4.lastCleaning = moment(ISODate);
        });
      });
    }
  }, {
    key: "getCleaningInProgress",
    value: function getCleaningInProgress() {
      var _this5 = this;

      return this.progressMonitorLayer.find(CONSTANTS.TAGS.START_AI_CLEANING).then(function (progressMonitors) {
        if (progressMonitors[0]) {
          runInAction(function () {
            _this5.progressMonitor = progressMonitors[0];
          });
          return true;
        } else {
          return false;
        }
      });
    }
  }, {
    key: "getCleaningProgress",
    value: function getCleaningProgress() {
      if (this.progressMonitor) {
        return this.progressMonitorLayer.status(this.progressMonitor.id);
      } else {
        return undefined;
      }
    }
  }]);

  return CategoryCleaningStateStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], CategoryCleaningStateStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Object)], CategoryCleaningStateStore.prototype, "progressMonitor", void 0);

__decorate([observable, __metadata("design:type", Object)], CategoryCleaningStateStore.prototype, "lastCleaning", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CategoryCleaningStateStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CategoryCleaningStateStore.prototype, "startCleaning", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CategoryCleaningStateStore.prototype, "getLastCleaning", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CategoryCleaningStateStore.prototype, "getCleaningInProgress", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CategoryCleaningStateStore.prototype, "getCleaningProgress", null);